import { SettingsForm } from "../components/SettingsForm";

export const Settings = () => {
  return <SettingsForm />;
};
